import { allFloorsType } from "./types";
// A mock function to mimic making an async request for data
export function lockUnlockaAll(floors: allFloorsType[], lockAll: boolean) {
    return new Promise<{ data: allFloorsType[] }>((resolve) =>
        setTimeout(() => {
            resolve({

                data: floors.map(ele => {
                    return {
                        ...ele, doors: ele.doors.map(d => {
                            return { ...d, isLocked: lockAll }
                        })
                    }
                })
            })
        }, 1500)
    );
}
export function lockUnLockSingle(floors: allFloorsType[], doorId: number) {
    return new Promise<{ data: allFloorsType[] }>((resolve) =>
        setTimeout(() => {
            resolve({

                data: floors.map(ele => {
                    return {
                        ...ele, doors: ele.doors.map(d => {

                            if (d.id === doorId) {
                                return { ...d, isLocked: !d.isLocked }

                            } else {
                                return d
                            }
                        })
                    }
                })
            })
        }, 1500)
    );
}
